<template>
  <div class="is-flex is-justify-content-space-between is-align-items-center">
    <label class="label">Status</label>
    <BaseDropdown
      :leftOffset="-10"
      wrapperClasses="column is-8 pr-0 pt-0"
      dialogClass="p-0"
      :onDialogChange="handleChange"
    >
      <template v-slot:toggle-button="{ handleToggle }">
        <div @click="handleToggle" class="pick-job-title-container">{{ value }}</div>
      </template>
      <div class="container py-3 px-2 max-width-dropdown">
        <label v-for="status in activeStatuses" :key="status.id">
          <input type="radio" name="status" :value="status.value" hidden />
          <p class="search_result has-text-right">{{ status.value }}</p>
        </label>
      </div>
    </BaseDropdown>
  </div>
</template>

<script>
import BaseDropdown from '@/components/BaseDropdown'
import { bus } from '@/custom/classes/bus.js'

export default {
  name: 'PositionStatus',
  components: {
    BaseDropdown
  },
  props: {
    value: {
      type: String
    },
    positionId: {
      type: Number
    }
  },
  computed: {
    activeStatuses () {
      return [
        { id: 1, value: 'active' },
        { id: 2, value: 'standby' },
        { id: 3, value: 'blocked' },
        { id: 4, value: 'expired' },
        { id: 5, value: 'editing' },
        { id: 6, value: 'fulfilled' },
        { id: 7, value: 'deleted' }
      ]
    }
  },
  methods: {
    async handleChange ({ target: { value: status } }, closeModal) {
      try {
        let active_at
        if (status == 'active') {
          active_at = new Date()
        }
        const res = await this.$network_utils.updatePosition({ position_id: this.positionId, status: status, active_at })
        // the server clears the flame when a position leaves active
        if (status !== 'active' && !(res && res.is_hot === true)) bus.$emit('position_flame_cleared', this.positionId)
        bus.$emit('position_status_changed', { position_id: this.positionId, status })
        this.$emit('input', status)
        closeModal()
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>

<style scoped>
  .max-width-dropdown {
    max-width: 500px;
    min-width: 250px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    max-height: 400px;
    overflow-y: scroll;
  }
  .pick-job-title-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
</style>
